import Vue     from 'vue'
import App     from './App.vue'
import router  from './router'
import store   from './store'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

require('./assets/styles/site.css');

/**
 * Les filtres en VueJS permettent de formatter une donnée avant de l'afficher
 */
Vue.filter('numberLocale', function(Value) {
  if (!Value) return ''
  return Value.toLocaleString()
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
